export default "__VITE_ASSET__CJQ5tEfG__"